import {combineReducers} from 'redux';
// @ts-expect-error
import {createReducer} from 'redux-act';

import type {ListSchemaResponse} from 'nutshell-core/schema/schema-types';

import * as actions from './connected-forms-actions';
import type {ConnectedFormsAction} from './types';

type SchemaState = ListSchemaResponse | null | undefined;

export const defaultConnectedFormsState = {
    activeFieldId: null,
    connectedFormSchema: null,
    timeseriesChart: {
        isLoading: true,
        isTimedOut: false,
        isErrored: false,
        chartData: null,
        prefix: '$',
    },
} as const;

// @ts-expect-error
const activeFieldReducer = (state = null, action) => {
    switch (action.type) {
        case 'ACTIVE_FIELD_ID_SET':
            return action.payload.activeFieldId;
        default:
            return state;
    }
};

const schemaReducer = (
    state: SchemaState | null | undefined = null,
    action: ConnectedFormsAction
): SchemaState => {
    switch (action.type) {
        case 'CONNECTED_FORMS_SCHEMA_UPDATED':
            return action.payload;
        default:
            return state;
    }
};

export const reportReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestReportData]: (state) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.updateReportChartData]: (state, {chartData}) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: false,
                isTimedOut: false,
                isErrored: false,
                chartData,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.failReportChartData]: (state, err) => {
            if (err) {
                if (err.status === 504 || err.status === 502) {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: true,
                        isErrored: false,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                } else {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: false,
                        isErrored: true,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                }
            }

            return state;
        },
    },
    defaultConnectedFormsState
);

export const connectedFormsReducer = combineReducers({
    connectedFormsReport: reportReducer,
    connectedFormSchema: schemaReducer,
    activeFieldId: activeFieldReducer,
});
